import { useDispatch, useSelector } from "react-redux";

import {
  downloadMaguireStatement,
  downloadStatement,
} from "../../store/modules/statementReport/statementReportActions";
import { RootState } from "../../store/store";
import { useMaguireWeeklyBillingCycleCutOffId, useIsMaguireEnabled } from "../../utils/maguireHelper";
import { ButtonSecondary } from "../Common/Buttons/Buttons";

export interface IDownloadStatementProps {
  billingCycleId: number;
  customerAccountId: number;
  onDownload(): void;
  statementId?: number;
  isWeeklyStatement?: boolean;
}

export default function DownloadStatement(props: IDownloadStatementProps) {
  const isMaguireEnabled = useIsMaguireEnabled();
  const weeklyBillingCycleCutOffId = useMaguireWeeklyBillingCycleCutOffId();
  const isMaguireWeeklyStatement = props.billingCycleId >= weeklyBillingCycleCutOffId;
  const dispatch = useDispatch();
  const bCycleId = useSelector((state: RootState) => state.statementReport.billingCycleId);
  const isDownloading = useSelector((state: RootState) => state.statementReport.isDownloading);
  const isWeekly = props.isWeeklyStatement === true;
  const downloadClicked = (customerId: number, cycleId: number, statementId?: number) => {
    if (isMaguireEnabled) {
      if (isWeekly && isMaguireWeeklyStatement) {
        downloadMaguireStatement(dispatch, customerId, statementId!, cycleId);
      } else {
        downloadStatement(dispatch, customerId, cycleId);
      }
    } else {
      downloadStatement(dispatch, customerId, cycleId);
    }
  };

  return (
    <ButtonSecondary
      fullWidth
      disabled={bCycleId === props.billingCycleId && isDownloading}
      type="button"
      onClick={
        isMaguireEnabled
          ? (event) => downloadClicked(props.customerAccountId, props.billingCycleId, props.statementId)
          : (event) => downloadClicked(props.customerAccountId, props.billingCycleId)
      }
    >
      <strong>{bCycleId === props.billingCycleId && isDownloading ? " Downloading..." : " Download Statement"}</strong>
    </ButtonSecondary>
  );
}
